var _excluded = ["theme", "noOfLines", "isTruncated", "css", "__css", "sx"],
  _excluded2 = ["baseStyle"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import _styled from '@emotion/styled';
import { css, propNames } from '../styled-system';
import { objectFilter, runIfFn } from '../utils';
import { shouldForwardProp } from './should-forward-prop';
import { domElements } from './system.utils';

/**
 * Convert propNames array to object to faster lookup perf
 */
var stylePropNames = propNames.reduce((acc, key) => {
  if (typeof key !== 'object' && typeof key !== 'function') acc[key] = key;
  return acc;
}, {});
/**
 * Style resolver function that manages how style props are merged
 * in combination with other possible ways of defining styles.
 *
 * For example, take a component defined this way:
 * ```jsx
 * <Box fontSize="24px" sx={{ fontSize: "40px" }}></Box>
 * ```
 *
 * We want to manage the priority of the styles properly to prevent unwanted
 * behaviors. Right now, the `sx` prop has the highest priority so the resolved
 * fontSize will be `40px`
 */
export var getStyleObject = _ref => {
  var {
    baseStyle
  } = _ref;
  return props => {
    var {
        theme,
        noOfLines,
        isTruncated,
        css: cssProp,
        __css,
        sx
      } = props,
      rest = _objectWithoutProperties(props, _excluded);

    // filter out props that aren't style props
    var styleProps = objectFilter(rest, (_, prop) => prop in stylePropNames);
    var truncateStyle = {};
    if (noOfLines != null) {
      truncateStyle = {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: noOfLines
      };
    } else if (isTruncated) {
      truncateStyle = {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
      };
    }

    /**
     * The computed, theme-aware style object. The other of the properties
     * within `objectAssign` determines how styles are overriden.
     */
    var finalStyles = Object.assign({}, __css, baseStyle, truncateStyle, styleProps, sx);

    // Converts theme-aware style object to real css object
    var computedCSS = css(finalStyles)(props.theme);

    // console.log(computedCSS);

    // Merge the computed css object with styles in css prop
    var cssObject = Object.assign(computedCSS, runIfFn(cssProp, theme));
    return cssObject;
  };
};
export function styled(component, options) {
  var _ref2 = options !== null && options !== void 0 ? options : {},
    {
      baseStyle
    } = _ref2,
    styledOptions = _objectWithoutProperties(_ref2, _excluded2);
  if (!styledOptions.shouldForwardProp) {
    styledOptions.shouldForwardProp = shouldForwardProp;
  }
  var styleObject = getStyleObject({
    baseStyle
  });
  return _styled(component, styledOptions)(styleObject);
}
export var tqc = styled;
domElements.forEach(tag => {
  tqc[tag] = tqc(tag);
});